import { z } from 'zod';

export const CareDocumentOutcomeSchema = z.object({
  initial: z.string().optional(),
  followUp: z.string().optional(),
  change: z.string().optional(),
});

export type CareDocumentOutcome = z.infer<typeof CareDocumentOutcomeSchema>;
